import React from 'react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: SelectOption[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-302">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-303">
          {label}
        </label>}
      <select id={selectId} className={`
          flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 
          focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50
          ${error ? 'border-red-500 focus:ring-red-500' : ''}
          ${className}
        `} {...props} data-id="element-304">
        {options.map(option => <option key={option.value} value={option.value} data-id="element-305">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-xs text-red-600" data-id="element-306">{error}</p>}
    </div>;
}